import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IDistributorFormMeta {
    piece: FormInputMeta;
    distributorEnvelope: FormInputMeta;

}

const distributorFormMeta = {} as IDistributorFormMeta;

distributorFormMeta.piece = {
    name: "piece",
    type: "select",
    label: "Pièce",
    placeholder: "Pièce",
    validation: yup.string().required("Champ obligatoire !")
};

distributorFormMeta.distributorEnvelope = {
    name: "distributorEnvelope",
    type: "select",
    label: "Enveloppe",
    placeholder: "Enveloppe",
    validation: yup.string().required("Champ obligatoire !")
};

export default distributorFormMeta;